__turbopack_context__.v({
  "imageAbsolute": "withBackground-module-scss-module___6qkpG__imageAbsolute",
  "relativeContainer": "withBackground-module-scss-module___6qkpG__relativeContainer",
});
